import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { VirtualizedTable } from '../../../common/VirtualizedTable/VirtualizedTable';
import { _multiFilterTable } from '../../../common/VirtualizedTable/virtualized-table-util';
import * as actions from '../../redux/schedules_actions';
import moment from 'moment-timezone'

class AgentSchedulesTable extends Component {
    constructor(props) {
		super(props);

        let columns = [{
            label: "ID",
            dataKey: "AgentID",
            width: 100
        }, {
            label: "Agent",
            dataKey: "AgentName",
            width: 250
        }, {
            label: "Management Unit",
            dataKey: "ManagementUnitName",
            width: 300
        }, {
            label: "Team",
            dataKey: "TeamName",
            width: 250
        }, {
            label: "Mon",
            dataKey: "Monday",
            width: 110
        }, {
            label: "Tue",
            dataKey: "Tuesday",
            width: 110
        }, {
            label: "Wed",
            dataKey: "Wednesday",
            width: 110
        }, {
            label: "Thu",
            dataKey: "Thursday",
            width: 110
        }, {
            label: "Fri",
            dataKey: "Friday",
            width: 110
        }, {
            label: "Sat",
            dataKey: "Saturday",
            width: 110
        }, {
            label: "Sun",
            dataKey: "Sunday",
            width: 110
        }];

        this.state = {
            selectedDay: moment().format('dddd'),
            columns: columns,
            list:  [],
            filteredList: [],
            managementUnitID: -1
        }

        this.generateMUFilter = this.generateMUFilter.bind(this);
        this.fetchSchedulesByMU = this.fetchAgentSchedulesByMU.bind(this);
        this.cellRenderer = this.cellRenderer.bind(this);
        this.headerRenderer = this.headerRenderer.bind(this);
    }

    componentWillUnmount = () => {
        // clear agent schedule datato allow table to populate 
        // if same MU is selected after user left page and came back.
        this.props.actions.clearAgentSchedules()
    }
    
    componentWillReceiveProps(nextProps) {        
        let currSchedules = JSON.stringify(this.props.AgentSchedules);
        let nextSchedules = JSON.stringify(nextProps.AgentSchedules);
        if (currSchedules !== nextSchedules) {
            this.setState({
                list: nextProps.AgentSchedules,
                filteredList: nextProps.AgentSchedules
            });
        }
        if (this.props.User !== nextProps.User)
            this.fetchAgentSchedules();

        if(this.props.SelectedDate !== nextProps.SelectedDate){
            this.setState({
                selectedDay: nextProps.SelectedDate.format('dddd')
            })
        }

        if(this.props.StartScheduledDayKey !== nextProps.StartScheduledDayKey) {
            this.fetchAgentSchedulesByMU(this.state.managementUnitID, nextProps.StartScheduledDayKey, nextProps.EndScheduledDayKey)
        }
    }

    fetchAgentSchedulesByMU(managementUnitID, startDate = null, endDate = null) {

        //clear search input text field
        this.refs.searchInput.value = '';

        if(managementUnitID > -1) {
            let StartScheduledDayKey = startDate !== null ? startDate : this.props.StartScheduledDayKey;
            let EndScheduledDayKey = endDate !== null ? endDate : this.props.EndScheduledDayKey;
            
            let params = { 
                StartScheduledDayKey: StartScheduledDayKey,
                EndScheduledDayKey: EndScheduledDayKey,
                ManagementUnitID: managementUnitID
            };

            this.setState({
                managementUnitID: managementUnitID
            })
            
            if(this.props.actions.fetchAgentSchedulesAction) {
                this.props.actions.fetchAgentSchedulesAction(params);           
            }
        }
    }

    generateMUFilter() {
        let { MUs } = this.props;
        let options = [];
        if (!MUs || MUs.length === 0) return null;
        for (let key in MUs)
            options.push(<option key={key} value={key}>{MUs[key]}</option>);
        return (
            <select
                className="schedules"
                onChange={(e) => this.fetchAgentSchedulesByMU(e.target.value)}>
                <option value="-1">Management Unit</option>
                { options }
            </select>
        );
    }

    cellRenderer ({
            cellData,
            columnData,
            columnIndex,
            dataKey,
            isScrolling,
            rowData,
            rowIndex
        }) {  
        let isDayHeader = this.state.managementUnitID !== -1 && Object.keys(this.props.WeekHeaders).indexOf(dataKey) > -1;
        let isSelectedDay = this.state.selectedDay === dataKey;
        if (isDayHeader && rowData[dataKey] === null) return <div className={ isSelectedDay ? "selected-cell center empty" : "center empty"}>-</div>;
        if (isDayHeader && rowData[dataKey]) {
            return (
                <div className={ isSelectedDay ? "selected-cell center" : "center"}>
                    <span>{  rowData[dataKey] !== null 
                            && moment.tz(rowData[dataKey].StartTime, "HH:mm A", "America/New_York").isValid()
                           ? moment.tz(rowData[dataKey].StartTime, "HH:mm A", "America/New_York").local().format("h:mm A") 
                           : rowData[dataKey].StartTime.length > 0 ? rowData[dataKey].StartTime : "-" }
                    </span>
                    <div>{   rowData[dataKey].EndTime !== null
                            && moment.tz(rowData[dataKey].EndTime, "HH:mm A", "America/New_York").isValid()
                           ? moment.tz(rowData[dataKey].EndTime, "HH:mm A", "America/New_York").local().format("h:mm A") 
                           : rowData[dataKey].StartTime.length > 0 ? "" : "-" }
                    </div>
                </div>
            );
        }
        if (dataKey === "AgentName") {
            let startDate = moment(this.props.StartScheduledDayKey).local().format('YYYY-MM-D')
            let agentScheduleLink = `Schedules/${startDate}/${rowData["AgentID"]}/${rowData["TeamID"]}/${rowData["ManagementUnitID"]}/${rowData["AgentName"]}`;
            return <Link to={agentScheduleLink}>{ cellData }</Link>;
        }
        return <div>{ cellData }</div>;
    }
    

    headerRenderer ({
            columnData,
            dataKey,
            disableSort,
            label,
            sortBy,
            sortDirection
        }) {
        let { WeekHeaders } = this.props;
        let isDayHeader = this.state.managementUnitID !== -1 && Object.keys(WeekHeaders).indexOf(dataKey) > -1;
        if (isDayHeader && WeekHeaders[dataKey]) {
            let isSelectedDay = this.state.selectedDay === dataKey;
            return (
                <div className="center">
                    <span className={ isSelectedDay ? "header-date selected" : "header-date"}>{ WeekHeaders[dataKey].Date }</span>
                    <div className="header-day">{ WeekHeaders[dataKey].Day }</div>
                </div>
            );
        }

        const showSortIndicator = sortBy === dataKey;
        const arrowClassName = sortDirection === "ASC" ? "up-arrow" : "down-arrow";
        return (<div>
                    { label }
                    { showSortIndicator
                    ? <span className={"arrows " + arrowClassName}></span> 
                    : "" }
                </div>); 
    }
    
    render() {
        let { columns, filteredList } = this.state;
        let _this = this;
        return (
            <div className="table-container agent-time-off-request">
                <input className="schedules" placeholder='Search ID or agent...' ref="searchInput" onChange={(e) => _multiFilterTable(e, ["AgentName", "AgentID"], _this)}></input>
                { this.generateMUFilter() }
                <div className="view-by">Weekly</div>
                <VirtualizedTable
                    sortBy={"AgentID"} 
                    columns={columns}
                    list={filteredList}
                    height={650}
                    width={500}
                    rowHeight={60}
                    headerHeight={60}
                    noRowsText={"There are no results that match your search. Please try again."}
                    headerRenderer={this.headerRenderer}
                    cellRenderer={this.cellRenderer}
                    disableHeight={true} />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        User: state.common.user,
        MUs: state.schedules.MUs,
        AgentSchedules: state.schedules.AgentSchedules,
        WeekHeaders: state.schedules.WeekHeaders,
        StartScheduledDayKey: state.schedules.selectedStartDate.format('MM/DD/YYYY'),
        EndScheduledDayKey: state.schedules.selectedEndDate.format('MM/DD/YYYY'),
        SelectedDate: state.schedules.selectedDate
	};
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch)
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(AgentSchedulesTable);



// WEBPACK FOOTER //
// ./src/features/schedules/Schedules/SupervisorSchedule/AgentSchedulesTable.js